import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

function Login() {
  const navigate = useNavigate();

  const [user, setUser] = useState({
    email: "",
    password: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setUser({
      ...user,
      [e.target.name]: e.target.value,
    });
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      const response = await axios.post(
        "/api/login",
        user
      );

      console.log(response);

      if (response.data.success) {
        // Store JWT Token
        localStorage.setItem("token", response.data.token);

        // Store Login Status
        localStorage.setItem("isLoggedIn", "true");

        // Store User Information
        localStorage.setItem(
          "user",
          JSON.stringify(response.data.user)
        );

        alert(response.data.message);

        navigate("/dashboard");
      }
    } catch (error) {
      if (error.response) {
        alert(error.response.data.message);
      } else {
        alert("Server not responding.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">

      {/* ================= HEADER ================= */}
      <header className="login-header">
        <div className="container-fluid px-4 px-lg-5">

          <div className="d-flex align-items-center justify-content-between">

            {/* Logo + Name */}
            <div className="d-flex align-items-center">

              <div className="brand-logo">
                <i className="bi bi-truck"></i>
              </div>

              <div className="ms-3">
                <h3 className="brand-title mb-0">
                  Transport Management System
                </h3>

                <small className="brand-subtitle">
                  Smart • Secure • Reliable Transportation
                </small>
              </div>

            </div>

            {/* Header Right */}
            <div className="header-info d-none d-md-flex align-items-center">
              <i className="bi bi-shield-check me-2"></i>
              Secure Login
            </div>

          </div>

        </div>
      </header>


      {/* ================= BODY ================= */}
      <main className="login-main">

        <div className="container">

          <div className="login-wrapper">

            <div className="row g-0">

              {/* ================= LEFT SIDE ================= */}
              <div className="col-lg-6">

                <div className="login-intro">

                  <div className="intro-content">

                    {/* Large Logo */}
                    <div className="intro-logo">
                      <i className="bi bi-truck"></i>
                    </div>

                    <h1>
                      Manage Your
                      <br />
                      <span>Transport Operations</span>
                    </h1>

                    <p className="intro-description">
                      Manage vehicles, drivers, shipments, routes,
                      parties and transportation operations from
                      one centralized platform.
                    </p>


                    {/* Features */}
                    <div className="feature-list">

                      <div className="feature-item">
                        <div className="feature-icon">
                          <i className="bi bi-truck"></i>
                        </div>

                        <div>
                          <strong>Fleet Management</strong>
                          <small>
                            Manage vehicles and transportation resources
                          </small>
                        </div>
                      </div>


                      <div className="feature-item">
                        <div className="feature-icon">
                          <i className="bi bi-box-seam"></i>
                        </div>

                        <div>
                          <strong>Shipment Tracking</strong>
                          <small>
                            Track consignments and dispatch information
                          </small>
                        </div>
                      </div>


                      <div className="feature-item">
                        <div className="feature-icon">
                          <i className="bi bi-bar-chart-line"></i>
                        </div>

                        <div>
                          <strong>Reports & Analytics</strong>
                          <small>
                            Get complete operational insights and reports
                          </small>
                        </div>
                      </div>

                    </div>

                  </div>

                </div>

              </div>


              {/* ================= RIGHT SIDE ================= */}
              <div className="col-lg-6">

                <div className="login-form-section">

                  <div className="login-form-container">

                    <div className="text-center mb-4">

                      <div className="form-icon">
                        <i className="bi bi-person-lock"></i>
                      </div>

                      <h2 className="login-title">
                        Welcome Back
                      </h2>

                      <p className="login-subtitle">
                        Sign in to access your transport dashboard
                      </p>

                    </div>


                    {/* Login Form */}
                    <form onSubmit={handleLogin}>

                      {/* Email */}
                      <div className="mb-3">

                        <label className="form-label">
                          Email Address
                        </label>

                        <div className="input-group custom-input">

                          <span className="input-group-text">
                            <i className="bi bi-envelope"></i>
                          </span>

                          <input
                            type="email"
                            name="email"
                            className="form-control"
                            placeholder="Enter your email"
                            value={user.email}
                            onChange={handleChange}
                            required
                          />

                        </div>

                      </div>


                      {/* Password */}
                      <div className="mb-3">

                        <label className="form-label">
                          Password
                        </label>

                        <div className="input-group custom-input">

                          <span className="input-group-text">
                            <i className="bi bi-lock"></i>
                          </span>

                          <input
                            type="password"
                            name="password"
                            className="form-control"
                            placeholder="Enter your password"
                            value={user.password}
                            onChange={handleChange}
                            required
                          />

                        </div>

                      </div>


                      {/* Remember / Forgot */}
                      <div className="d-flex justify-content-between align-items-center mb-4">

                        <div className="form-check">

                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="rememberMe"
                          />

                          <label
                            className="form-check-label"
                            htmlFor="rememberMe"
                          >
                            Remember me
                          </label>

                        </div>

                        <Link
                          to="/forgot-password"
                          className="forgot-link"
                        >
                          Forgot Password?
                        </Link>

                      </div>


                      {/* Login Button */}
                      <button
                        type="submit"
                        className="btn login-btn w-100"
                        disabled={loading}
                      >

                        {loading ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm me-2"
                            ></span>

                            Signing In...
                          </>
                        ) : (
                          <>
                            Sign In
                            <i className="bi bi-arrow-right ms-2"></i>
                          </>
                        )}

                      </button>

                    </form>


                    {/* Register */}
                    <div className="register-section">

                      <span>
                        Don't have an account?
                      </span>

                      <Link to="/register">
                        Create Account
                      </Link>

                    </div>


                    {/* Security Message */}
                    <div className="security-message">

                      <i className="bi bi-shield-lock-fill"></i>

                      <span>
                        Your login information is protected
                        with secure authentication.
                      </span>

                    </div>

                  </div>

                </div>

              </div>

            </div>

          </div>

        </div>

      </main>


      {/* ================= FOOTER ================= */}
      <footer className="login-footer">

        <div className="container">

          <div className="row align-items-center">

            {/* Footer Brand */}
            <div className="col-md-5 mb-3 mb-md-0">

              <div className="footer-brand">
                <i className="bi bi-truck"></i>

                <strong>
                  Transport Management System
                </strong>
              </div>

              <p className="footer-description">
                Complete transportation management solution
                for efficient fleet, shipment and logistics
                operations.
              </p>

            </div>


            {/* Footer Information */}
            <div className="col-md-7">

              <div className="row">

                <div className="col-sm-4 footer-item">
                  <i className="bi bi-geo-alt"></i>
                  <span>
                    Transport Operations
                  </span>
                </div>

                <div className="col-sm-4 footer-item">
                  <i className="bi bi-headset"></i>
                  <span>
                    Support Available
                  </span>
                </div>

                <div className="col-sm-4 footer-item">
                  <i className="bi bi-shield-check"></i>
                  <span>
                    Secure Platform
                  </span>
                </div>

              </div>

            </div>

          </div>


          <hr />


          <div className="footer-bottom">

            <span>
              © {new Date().getFullYear()} Transport Management System.
              All Rights Reserved.
            </span>

            <span>
              Designed for efficient transportation management.
            </span>

          </div>

        </div>

      </footer>


      {/* ================= CSS ================= */}
      <style>{`

        * {
          box-sizing: border-box;
        }

        body {
          margin: 0;
          font-family: "Inter", "Segoe UI", Arial, sans-serif;
        }

        .login-page {
          min-height: 100vh;
          background: #f4f7fb;
          display: flex;
          flex-direction: column;
        }


        /* ================= HEADER ================= */

        .login-header {
          background: #0f172a;
          color: white;
          padding: 16px 0;
          box-shadow: 0 3px 15px rgba(0,0,0,.15);
        }

        .brand-logo {
          width: 48px;
          height: 48px;
          border-radius: 12px;
          background: linear-gradient(
            135deg,
            #2563eb,
            #1d4ed8
          );

          display: flex;
          align-items: center;
          justify-content: center;

          font-size: 24px;

          box-shadow:
            0 8px 20px rgba(37,99,235,.35);
        }

        .brand-title {
          font-size: 21px;
          font-weight: 700;
        }

        .brand-subtitle {
          color: #94a3b8;
        }

        .header-info {
          color: #cbd5e1;
          font-size: 14px;
        }


        /* ================= MAIN ================= */

        .login-main {
          flex: 1;
          display: flex;
          align-items: center;
          padding: 45px 0;
        }

        .login-wrapper {
          max-width: 1050px;
          margin: auto;
          background: white;
          border-radius: 22px;
          overflow: hidden;

          box-shadow:
            0 20px 60px rgba(15,23,42,.12);
        }


        /* ================= LEFT ================= */

        .login-intro {
          height: 100%;
          min-height: 590px;

          background:
            linear-gradient(
              145deg,
              #172554,
              #1e3a8a,
              #2563eb
            );

          color: white;

          position: relative;
          overflow: hidden;
        }

        .login-intro::before {
          content: "";
          position: absolute;

          width: 320px;
          height: 320px;

          border-radius: 50%;

          background: rgba(255,255,255,.07);

          top: -120px;
          right: -100px;
        }

        .login-intro::after {
          content: "";
          position: absolute;

          width: 220px;
          height: 220px;

          border-radius: 50%;

          background: rgba(255,255,255,.06);

          bottom: -100px;
          left: -80px;
        }

        .intro-content {
          position: relative;
          z-index: 2;

          padding: 55px 50px;
        }

        .intro-logo {
          width: 75px;
          height: 75px;

          border-radius: 18px;

          display: flex;
          align-items: center;
          justify-content: center;

          background: rgba(255,255,255,.15);

          backdrop-filter: blur(10px);

          font-size: 38px;

          margin-bottom: 28px;
        }

        .intro-content h1 {
          font-size: 38px;
          line-height: 1.2;
          font-weight: 800;
          margin-bottom: 20px;
        }

        .intro-content h1 span {
          color: #93c5fd;
        }

        .intro-description {
          color: #dbeafe;
          line-height: 1.7;
          font-size: 15px;
          max-width: 450px;
        }


        /* ================= FEATURES ================= */

        .feature-list {
          margin-top: 35px;
        }

        .feature-item {
          display: flex;
          align-items: center;
          margin-bottom: 20px;
        }

        .feature-icon {
          width: 45px;
          height: 45px;

          border-radius: 12px;

          background: rgba(255,255,255,.13);

          display: flex;
          align-items: center;
          justify-content: center;

          margin-right: 14px;

          font-size: 20px;
        }

        .feature-item strong {
          display: block;
          font-size: 15px;
        }

        .feature-item small {
          color: #bfdbfe;
          display: block;
          margin-top: 3px;
        }


        /* ================= FORM SIDE ================= */

        .login-form-section {
          min-height: 590px;

          display: flex;
          align-items: center;
          justify-content: center;

          padding: 40px;
        }

        .login-form-container {
          width: 100%;
          max-width: 390px;
        }

        .form-icon {
          width: 65px;
          height: 65px;

          margin: auto;
          margin-bottom: 15px;

          border-radius: 18px;

          display: flex;
          align-items: center;
          justify-content: center;

          background: #eff6ff;
          color: #2563eb;

          font-size: 28px;
        }

        .login-title {
          font-size: 29px;
          font-weight: 750;
          color: #0f172a;
        }

        .login-subtitle {
          color: #64748b;
          font-size: 14px;
        }


        /* ================= INPUT ================= */

        .form-label {
          font-weight: 600;
          font-size: 14px;
          color: #334155;
        }

        .custom-input {
          border-radius: 10px;
          overflow: hidden;
        }

        .custom-input .input-group-text {
          background: #f8fafc;
          border-color: #dbe2ea;
          color: #64748b;
        }

        .custom-input .form-control {
          height: 48px;
          border-color: #dbe2ea;
          box-shadow: none;
        }

        .custom-input .form-control:focus {
          border-color: #2563eb;
          box-shadow: 0 0 0 3px rgba(37,99,235,.1);
        }


        /* ================= LOGIN BUTTON ================= */

        .login-btn {
          height: 50px;

          border: none;

          border-radius: 10px;

          color: white;

          font-weight: 600;
          font-size: 15px;

          background:
            linear-gradient(
              135deg,
              #2563eb,
              #1d4ed8
            );

          box-shadow:
            0 8px 20px rgba(37,99,235,.25);

          transition: all .25s ease;
        }

        .login-btn:hover {
          transform: translateY(-2px);

          box-shadow:
            0 12px 25px rgba(37,99,235,.35);
        }

        .login-btn:disabled {
          opacity: .75;
          transform: none;
        }


        /* ================= LINKS ================= */

        .forgot-link {
          text-decoration: none;
          color: #2563eb;
          font-size: 13px;
          font-weight: 600;
        }

        .register-section {
          text-align: center;
          margin-top: 25px;

          font-size: 14px;

          color: #64748b;
        }

        .register-section a {
          color: #2563eb;
          text-decoration: none;
          font-weight: 700;
          margin-left: 5px;
        }


        /* ================= SECURITY ================= */

        .security-message {
          margin-top: 25px;

          padding: 12px;

          border-radius: 10px;

          background: #f8fafc;

          color: #64748b;

          font-size: 12px;

          display: flex;
          align-items: center;
          gap: 8px;
        }

        .security-message i {
          color: #16a34a;
          font-size: 16px;
        }


        /* ================= FOOTER ================= */

        .login-footer {
          background: #0f172a;
          color: #cbd5e1;

          padding: 25px 0 18px;
        }

        .footer-brand {
          display: flex;
          align-items: center;
          gap: 10px;

          color: white;

          font-size: 15px;
        }

        .footer-brand i {
          color: #60a5fa;
          font-size: 22px;
        }

        .footer-description {
          margin: 8px 0 0;

          font-size: 12px;

          color: #94a3b8;

          max-width: 420px;

          line-height: 1.5;
        }

        .footer-item {
          display: flex;
          align-items: center;

          gap: 8px;

          font-size: 12px;

          margin-bottom: 10px;
        }

        .footer-item i {
          color: #60a5fa;
          font-size: 17px;
        }

        .login-footer hr {
          border-color: #334155;
          margin: 18px 0;
        }

        .footer-bottom {
          display: flex;
          justify-content: space-between;
          gap: 15px;

          font-size: 11px;

          color: #64748b;
        }


        /* ================= RESPONSIVE ================= */

        @media (max-width: 991px) {

          .login-intro {
            min-height: auto;
          }

          .intro-content {
            padding: 40px;
          }

          .intro-content h1 {
            font-size: 32px;
          }

          .login-form-section {
            min-height: auto;
            padding: 45px 35px;
          }

        }


        @media (max-width: 767px) {

          .login-header {
            padding: 13px 0;
          }

          .brand-title {
            font-size: 16px;
          }

          .brand-subtitle {
            font-size: 10px;
          }

          .brand-logo {
            width: 40px;
            height: 40px;
            font-size: 19px;
          }

          .login-main {
            padding: 20px 12px;
          }

          .login-wrapper {
            border-radius: 16px;
          }

          .intro-content {
            padding: 35px 25px;
          }

          .intro-content h1 {
            font-size: 27px;
          }

          .intro-description {
            font-size: 14px;
          }

          .login-form-section {
            padding: 35px 22px;
          }

          .login-title {
            font-size: 25px;
          }

          .footer-bottom {
            flex-direction: column;
            text-align: center;
          }

          .login-footer {
            padding-left: 15px;
            padding-right: 15px;
          }

        }

      `}</style>

    </div>
  );
}

export default Login;
